import { chartMapper } from "components/Charts";
import Widget from "components/Layout/Widget";
import { DashboardWidgetConfig } from "config/config";
import { getUserData, getUserPermissions } from "containers/Auth/Auth.selectors";
import { getStatData } from "containers/Stats/Stats.selectors";
import { useSelector } from "react-redux";

interface DashboardProps {
    dashboardItem: DashboardWidgetConfig;
    recordId: string;
    resourceData: any;
    isEmpty?: boolean;
}

export const WidgetWrapper = ({
    dashboardItem,
    recordId,
    resourceData,
    isEmpty,
}: DashboardProps) => {
    const stats = useSelector(getStatData);
    const userData = useSelector(getUserData);
    const userPermissions = useSelector(getUserPermissions);

    const WidgetComponent = chartMapper[dashboardItem.component as keyof typeof chartMapper];

    if (dashboardItem?.omitWhen) {
        return null;
    }

    return (
        <Widget
            key={`project-${recordId}-widget-${dashboardItem?.uid}`}
            className={dashboardItem?.className}
            title={dashboardItem?.title}
            subtitle={dashboardItem?.subtitle}
            link={
                dashboardItem?.link
                    ? dashboardItem?.link(recordId, resourceData, userData, userPermissions)
                    : null
            }
            linkLabel={dashboardItem?.linkLabel}
            dataTestId={dashboardItem?.dataTestId}
        >
            {isEmpty ? (
                <Widget.Empty />
            ) : (
                <WidgetComponent config={dashboardItem} resourceData={resourceData} stats={stats} />
            )}
        </Widget>
    );
};
